/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'media/images/logo.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

// app/javascript/packs/application.js

// Import dependencies
import Rails from "@rails/ujs";
import Turbolinks from "turbolinks";
import * as ActiveStorage from "@rails/activestorage";
import "../channels";
// import "@hotwired/turbo-rails";
// import "../controllers";
// Setup Rails UJS
Rails.start();
Turbolinks.start();
ActiveStorage.start();

// React setup
import React from "react";
// Use createRoot from react-dom/client for React 18+
import { createRoot } from "react-dom/client";
// import ReactRailsUJS from "react_ujs"; // Keep commented out

// Import jQuery and jQuery plugins
import jQuery from "jquery";
window.$ = window.jQuery = jQuery; // Allow Webpacker jQuery to become global

// Import other dependencies
// import "jquery-ujs"; // Replaced by @rails/ujs
import "jquery-datatables";
import "select2";
// Import geocomplete plugin
import "../src/jquery.geocomplete";
import Swiper from "swiper";
import "isotope-layout";
import "skrollr";
import "sweetalert";
import "cocoon-js";

// Import Slick Carousel library and styles
import "slick-carousel/slick/slick";
import "slick-carousel/slick/slick.css"; // Handled by Sprockets/application.scss
import "slick-carousel/slick/slick-theme.css"; // Handled by Sprockets/application.scss

// Import component registry (adjust path if needed)
import componentRegistry from "../src/component_loader";

// Set up global exports for React (Optional, keep if other JS needs it)
window.React = React;
// window.ReactDOM = ReactDOM; // createRoot is now used
window.Swiper = Swiper;

// Set up React Rails UJS (Keep commented out)
// ReactRailsUJS.mountComponents();

// --- Webpacker Native React Mounting ---
const mountReactComponents = () => {
  console.log("Scanning for React component roots...");
  document.querySelectorAll(".react-root").forEach((element) => {
    const componentName = element.dataset.component;
    const propsJson = element.dataset.props;
    const Component = componentRegistry[componentName];

    if (Component) {
      try {
        const props = propsJson ? JSON.parse(propsJson) : {};
        // Use createRoot for React 18+
        const root = createRoot(element);
        root.render(React.createElement(Component, props));
        console.log(`Mounted component: ${componentName}`);
      } catch (e) {
        console.error(`Error mounting component ${componentName}:`, e, {
          propsJson,
        });
      }
    } else {
      console.warn(`Component "${componentName}" not found in registry.`);
    }
    // Optional: Clean up data attributes to prevent potential re-mounting
    // if this code accidentally runs twice on the same element.
    // element.removeAttribute('data-component');
    // element.removeAttribute('data-props');
    // element.classList.remove('react-root'); // Be careful if styling relies on this class
  });
};

document.addEventListener("turbolinks:load", mountReactComponents);
// Optional fallback for initial load:
// document.addEventListener('DOMContentLoaded', mountReactComponents);
// --- End React Mounting ---

// Import your custom JavaScript modules
// Example: import '../components/bucket_list';
// Example: import '../components/main';

// Example assuming you moved them to app/javascript/src/
import "../src/bucket_list";
import "../src/slick_init";
import "../src/embla_tribe_carousel";
import "../src/event_calendar";
import "../src/gptApi";
import "../src/itinerary";
import "../src/Search";
import "../src/admin/tiptap_mount";
import "../src/admin_sorting";
import "../src/admin/carouselPreview";
import "../src/admin/experience";
import "../src/admin/init_datatables";
import "../src/admin/media_library";
import "../src/admin/scroll";
import "../src/admin/tribe";
import "../src/admin/tribes_index_enhancements";
import "./photo_manager";
import "../src/region";
import "../src/region_globe";
import "../src/dropdown_nav";
import "../src/share";
import "../src/newsletter_toggle";
console.log("Webpacker application.js loaded");
